export default "__VITE_ASSET__Ccb5qA_7__"